import React from 'react';
import { useState } from 'react';
import axios from '../../../api/axios';
import { useContext } from 'react';
import AuthContext from '../../../api/AuthProvider';

const FeedCreate = () => {
    const [content, setContent] = useState('');
    const [message, setMessage] = useState('');
    const { user } = useContext(AuthContext);

    const postContent = async (e) => {
        // const myTokens = JSON.parse(localStorage.getItem('authTokens'));
        // const myAccess = myTokens.access;
        try {
            const requestBody = {
                content: content,
            };
            let response = await axios.post(
                '/api/social/add/',
                JSON.stringify(requestBody),
                {
                    headers: {
                        // Authorization: 'Bearer ' + myAccess,
                        'Content-Type': 'application/json',
                    },
                    withCredentials: true,
                }
            );
            if (response.status === 200) {
                // test the error message by un-commenting next line and commenting out everything else before the 'else'.
                // setMessage('Error')
                setContent('');
                //refreshes page upon posting
                window.location.reload(false);
            } else {
                setMessage('Error');
            }
        } catch (err) {}
    };

    const handleChange = (e) => {
        setContent(e.target.value);
    };

    return (
        <div className="feed-create">
            <div className="feed-create-content">
                <input
                    type="text"
                    placeholder={`What are you thinking about, ${user.firstname}?`}
                    className="field-feed"
                    value={content}
                    onChange={handleChange}
                />
                <button className="post-button" onClick={postContent}>
                    Post
                </button>
                <i className="bi-paperclip bi-icon-md" />
            </div>
            <p className="feed-create-attach">Attachment</p>
            {message && <div className="error">{message}</div>}
        </div>
    );
};

export default FeedCreate;
